export const RESOURCE_ROUTES = {
  businesses: (i) => `/empresa/${i.id}`,
  services: (i) => `/servico/${i.id}`,
  products: (i) => (i.id ? `/produto/${i.id}` : "#"),
  promotions: (i) => (i.business_id ? `/empresa/${i.business_id}` : "/#promotions"),
  coupons: (i) => (i.business_id ? `/empresa/${i.business_id}` : "/#coupons"),
  news: (i) => `/noticia/${i.id}`,
  events: (i) => `/evento/${i.id}`,
  tourist_spots: (i) => `/ponto-turistico/${i.id}`,
  jobs: () => "/#jobs",
  rentals: () => "/#rentals",
  commercial_spots: () => "/#commercial_spots",
  categories: (i) => `/empresas?categoria=${encodeURIComponent(i.name)}`,
};

export const RESOURCE_LABELS = {
  businesses: "Empresa", services: "Serviço", products: "Produto", promotions: "Promoção", coupons: "Cupom",
  news: "Notícia", events: "Evento", tourist_spots: "Ponto Turístico", jobs: "Vaga",
  rentals: "Imóvel", commercial_spots: "Ponto Comercial", categories: "Categoria",
};

export const itemTitle = (item) => item.name || item.title || item.code || "";
